import "./aside.scss";
import SectionTitle from "../sectionTitle/SectionTitle";
import OtherCategories from "../otherCategories/OtherCategories";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { I18nContext } from "../../i18n";
import AdComponent from "../adComponents/AdComponent";
import { getStickyPosts } from "../../dataProvider/posts";
import Article from "../article/Article";
import SeeAsWell from "../SeeAswell/SeeAsWell";

const Aside = ({ otherCategory, topPub, seeAsWell }) => {
	const [articles, setArticles] = useState([]);
	const { translate } = useContext(I18nContext);
	const { currentTag } = useContext(AppContext);

	useEffect(() => {
		currentTag !== undefined && getStickyPosts(currentTag, 2).then((res) => setArticles(res));
	}, [currentTag]);

	return (
		<aside className="aside">
			<SectionTitle title={translate("aside").bestOf} />
			{topPub && (
				<div className="aside__ad">
					<AdComponent className="ad-square" />
				</div>
			)}
			<div className="aside__articles">
				{articles.length > 0 &&
					articles.map((article, i) => {
						return (
							<Article
								key={article.id}
								title={article.title?.rendered}
								img={article["_embedded"]["wp:featuredmedia"]?.[0]["source_url"]}
								to={article.slug}
							/>
						);
					})}
			</div>
			{otherCategory && <OtherCategories />}
			{seeAsWell && <SeeAsWell />}
			<div className="aside__ad">
				<AdComponent className="ad-square" />
			</div>
		</aside>
	);
};

export default Aside;
